import { ComponentPropsWithoutRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { twMerge } from 'tailwind-merge';

interface QuickBooksRootProps extends ComponentPropsWithoutRef<'div'> {}
const QuickBooksRoot = ({ className, children, ...rest }: QuickBooksRootProps) => {
    return (
        <div className={twMerge('flex flex-col gap-4 pb-24', className)} {...rest}>
            {children}
        </div>
    );
};

interface QuickBooksHeaderProps extends ComponentPropsWithoutRef<'div'> {}
const QuickBooksHeader = ({ className, children, ...rest }: QuickBooksHeaderProps) => {
    return (
        <div
            className={twMerge(
                'flex min-h-10 flex-wrap items-center justify-between gap-4',
                className,
            )}
            {...rest}
        >
            {children}
        </div>
    );
};

interface QuickBooksLogoProps extends Omit<LinkProps, 'to'>, Partial<Pick<LinkProps, 'to'>> {}
const QuickBooksLogo = ({ className, to, ...rest }: QuickBooksLogoProps) => {
    const { accountId } = useCurrentAccount();
    const destination = to ?? `/accounts/${accountId}/settings/integrations/quickbooks`;

    return (
        <Link
            to={destination}
            className={twMerge('text-black hover:text-black', className)}
            {...rest}
        >
            <div className="flex items-center gap-3 text-2xl font-medium">
                <img
                    alt="QuickBooks"
                    className="max-h-8"
                    src={`/images/logos/quickbooks_logo.svg`}
                />
                QuickBooks
            </div>
        </Link>
    );
};

const Root = QuickBooksRoot;
const Header = QuickBooksHeader;
const Logo = QuickBooksLogo;

export {
    Root,
    Header,
    Logo,
    //
    QuickBooksRoot,
    QuickBooksHeader,
    QuickBooksLogo,
};

export type { QuickBooksRootProps, QuickBooksHeaderProps, QuickBooksLogoProps };
